<template>
  <div class="timepicker">
    <ul class="timepicker__list">
      <li
        v-for="i of Array.range(from, to, step)"
        :key="`timepicker-${type}-${i}`"
        :class="selected === i && 'timepicker__item--selected'"
        class="timepicker__item"
        @click="fn(i)"
      >
        {{ String(i).padStart(2, '0') }}
      </li>
    </ul>
  </div>
</template>

<script>
Array.range = (from, to, step) => Array.from({length: ~~((to - from) / step) + 1}, (v, k) => from + k * step)

export default {
  name: 'DrAppointmentTimePicker',

  props: {
    type: {
      type: String,
      required: true,
      default: () => 'minute' // type can be 'hour'
    },

    from: {
      type: Number,
      required: false,
      default: () => 0
    },

    selected: {
      type: Number,
      required: false,
      default: () => 0
    },

    fn: {
      type: Function,
      required: true,
      default: () => {}
    }
  },

  computed: {
    to () {
      return (this.type === 'minute')
        ? 59
        : 23
    },

    step () {
      return (this.type === 'minute')
        ? 5
        : 1
    }
  },

  mounted () {
    const timepicker = document.querySelector('.timepicker')
    const selectedItem = document.querySelector('.timepicker__item--selected')
    timepicker.scrollTop = selectedItem.offsetTop
  }
}
</script>
